import { Action, ActionReducerMap } from '@ngrx/store';

import * as fromUserSettingsEntity from './user-settings-entity/user-settings-entity.reducer';
import * as fromUserSettings from './user-settings/user-settings.reducer';
import { UserAccountState } from './user-account.state';
import { userPasswordReducer } from './user-password/user-password.reducer';

export const userAccountReducer: ActionReducerMap<UserAccountState, Action> = {
  userSettingsEntityState: fromUserSettingsEntity.reducer,
  userSettingsState: fromUserSettings.reducer,
  userPasswordState: userPasswordReducer
};
